import { useQuery } from '@tanstack/react-query';
import { PolicyApi } from '@Apis';
import { OverAllPolicyType, ServiceCollection } from '../../utils/types';
import { transformRawPolicyData } from '../utils/policyTransforms';
import { useMemo } from 'react';

export const createPolicyQueryKey = (
  overAllPolicyType: OverAllPolicyType,
  collectionType: ServiceCollection,
  orgId: string
) => ['policies', overAllPolicyType, collectionType, orgId] as const;

export const usePolicyListQuery = (
  overAllPolicyType: OverAllPolicyType,
  collectionType: ServiceCollection,
  orgId: string
) => {
  const queryKey = createPolicyQueryKey(
    overAllPolicyType,
    collectionType,
    orgId
  );

  const query = useQuery({
    queryKey,
    queryFn: () =>
      PolicyApi.apiGetPolicies(overAllPolicyType, collectionType, orgId),
    enabled: orgId !== 'all',
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  const policyLists = useMemo(() => {
    if (!query.data?.data) {
      return {};
    }
    return transformRawPolicyData(query.data.data, collectionType);
  }, [query.data, collectionType]);

  const policyTypes = useMemo(() => {
    return Object.keys(policyLists).filter((k) => policyLists[k].length > 0);
  }, [policyLists]);

  return {
    ...query,
    policyLists,
    policyTypes,
  };
};
